import { css } from '@emotion/react';
import t from 'react-translate';
import { genAIGradientType4 } from 'styles/global_defaults/colors';
import { doubleSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import {
  ReactComponent as AIPersona,
} from 'styles/icons/ai-persona.svg';

type AiChatProps = {
  content: string;
};

const styles = css`
  .ai-profile {
    width: ${doubleSpacing}px;
    height: ${doubleSpacing}px;
  }
  .ai-chat-bubble {
    border-radius: ${standardSpacing}px;
    background:
      linear-gradient(white, white) padding-box,
      ${genAIGradientType4} border-box;
    border: 1px solid transparent;
    min-height: 45px;
    max-width: 75%;
  }
`;

const AiChat = (props: AiChatProps) => {
  const { content } = props;

  return (
    <div css={styles} className='d-flex left-0'>
      <div className='ai-profile'>
        <AIPersona
          width={doubleSpacing}
          height={doubleSpacing}
          role='img'
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.AI_CHARACTER_AVATAR()}
        />
      </div>
      <div className='ai-chat-bubble ml-2 py-2 px-4 d-flex align-items-center'>
        <p className='mb-0'>{content}</p>
      </div>
    </div>
  );
};

export default AiChat;
